// extracted by mini-css-extract-plugin
module.exports = {"container":"PartnersOrder_container__3yCzz"};